import type { ScreenPoint } from './CommandExecutor';

const TEXT_INPUT_TYPES = ['text', 'search', 'email', 'tel', 'url', 'password', 'number', ''];

export function isTextField(element: Element): element is HTMLInputElement | HTMLTextAreaElement {
    const view = element.ownerDocument.defaultView;

    if (!view) {
        return false;
    }

    return element instanceof view.HTMLTextAreaElement || (element instanceof view.HTMLInputElement && TEXT_INPUT_TYPES.includes(element.type));
}

// Browsers resolve `cursor: auto` themselves (I-beam over text): reproduce that so both sides show the cursor the page would.
export function resolveCssCursor(element: Element, point: ScreenPoint): string {
    const targetDocument = element.ownerDocument;
    const cursor = targetDocument.defaultView?.getComputedStyle(element).cursor || 'auto';

    if (cursor !== 'auto') {
        return cursor;
    }

    return isTextField(element) || (element as HTMLElement).isContentEditable || isOverText(targetDocument, point) ? 'text' : 'default';
}

function isOverText(targetDocument: Document, point: ScreenPoint): boolean {
    const range = targetDocument.caretRangeFromPoint?.(point.x, point.y);

    if (!range || range.startContainer.nodeType !== Node.TEXT_NODE || !range.startContainer.textContent?.trim()) {
        return false;
    }

    const textRange = targetDocument.createRange();
    textRange.selectNodeContents(range.startContainer);

    return Array.from(textRange.getClientRects()).some((rect) => point.x >= rect.left && point.x <= rect.right && point.y >= rect.top && point.y <= rect.bottom);
}
